import React, { useContext } from 'react';
import DesktopDevPageSide300x250 from '@wix/da-ads/pkg/adunits/DesktopDevPageSide300x250';
import DesktopDevPageSide300x250Atf from '@wix/da-ads/pkg/adunits/DesktopDevPageSide300x250Atf';
import MobileDevPageSide300x250 from '@wix/da-ads/pkg/adunits/MobileDevPageSide300x250';
import DesktopDevPageSideVideoSide from '@wix/da-ads/pkg/adunits/DesktopDevPageSideVideoSide';
import ErrorBoundary from '../../../../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import cn from 'classnames';
import s from './Ad.scss';
const Ad = ({ block , adSafety , deviation  })=>{
    const isMobile = useContext(MobileContext);
    const showAd = useShouldRenderAdArea(adSafety);
    const isPrimis = useFlag('ads_primis_top');
    if (!showAd) {
        return null;
    }
    // Mobile only has BTF
    if (isMobile && block.contentType === 'ad_top') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], block.contentType === 'ad_btf' && s['display-root'])
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SidebarAd"
    }, block.contentType === 'ad_top' && !isPrimis && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['video'])
    }, /*#__PURE__*/ React.createElement(DesktopDevPageSideVideoSide, {
        safety: adSafety
    })), block.contentType === 'ad_top' && isPrimis && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['display-atf'])
    }, /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Atf, {
        safety: adSafety
    })), block.contentType === 'ad_btf' && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['display'])
    }, !isMobile && /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250, {
        safety: adSafety
    }), isMobile && /*#__PURE__*/ React.createElement(MobileDevPageSide300x250, {
        safety: adSafety
    }))));
};
Ad.displayName = 'Ad';
export default Ad;
